import React, { useState, useEffect } from 'react';

export default function  AlertOffline() {

    const [checkOffline, setCheckOffline] = useState(false);
    useEffect(() => {
        window.addEventListener('offline', () => setCheckOffline(true));
        window.addEventListener('online', () => setCheckOffline(false));
        return () => {
            window.removeEventListener('offline', () => setCheckOffline(true));
            window.removeEventListener('online', () => setCheckOffline(false));
        };
    }, []);
    

    return (
        <div className={`alert-offline ${checkOffline ? "show-alert-offline" : ""}`}>
            <p>現在オフラインになっています</p>
        </div>
    );
}